import { TrackingDetailsService } from '../services/TrackingDetailsService';

export function useTrackingDetailsService(): TrackingDetailsService {
  return new TrackingDetailsService(useApiClient(), useUserStore());
}
